import { AppBar, Breadcrumbs, Typography } from "@mui/material";
import { emphasize, styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import NavigateNextIcon from "@mui/icons-material/NavigateNextRounded";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./style.css";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

const useStyles = makeStyles((theme) => ({
  appbar: {
    backgroundColor: "#d3d4d6",
    boxShadow: "none",
    height: 50,
    padding: "0 150px",
    zIndex: "1001",
    [theme.breakpoints.down("md")]: {
      height: 80,
      padding: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      height: 45,
      justifyContent: "space-between",
    },

  },
  toolbar: {
    height: "50px !important",
    minHeight: "unset",
    [theme.breakpoints.down("md")]: {
      height: 80,
      justifyContent: "space-between",
    },
  },
  appbar3: {
    backgroundColor: "rgba(0,0,0, 0.3)",
    top: "130px !important",
    height: 40,
    padding: "5px 190px",
    [theme.breakpoints.down("md")]: {
      top: "50px !important",
      padding: "5px",
    },
  },
  ol: {
    flexWrap: "nowrap",
    overflowX: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

const CustomBreadcrumbs = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const breadcrumb = useSelector((state) => state.breadcrumb);

  return (
    <AppBar
      ref={props.newBreadcrumb}
      className={clsx(classes.appbar, classes.appbar3, "breadcrumbmain")}
    // style={{ marginTop: "3.3%" }}
    >
      <Breadcrumbs
        separator={
          <NavigateNextIcon style={{ color: "white" }} fontSize="small" />
        }
        aria-label="breadcrumb"
        classes={{
          ol: clsx(classes.ol, "noscrollbar"),
        }}
      >
        <StyledBreadcrumb
          component="a"
          onClick={() => navigate("/")}
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        />
        {breadcrumb.items.map((item) => {
          return (
            <StyledBreadcrumb
              component="span"
              onClick={() => {
                if (item.url) {
                  navigate(item.url);
                }
              }}
              label={item.title}
            />
          );
        })}
      </Breadcrumbs>
    </AppBar>
  );
};

export default CustomBreadcrumbs;
